(function(){
    'use strict';
    angular.module('Services').factory('isUniqueService', isUniqueService);    
    isUniqueService.$inject = ['toastr', '$timeout'];
    function isUniqueService(toastr, $timeout) {
        let service = this;
        service.isUnique = isUnique;

        /**
         * Check if the value already exists in the database
         * 
         * @param { object } paramObject
         */
        function isUnique(paramObject) {
            let model = paramObject.model;
            let formField = paramObject.formField;
            let service = paramObject.service;
            let serviceMethod = paramObject.serviceMethod;
            let property = paramObject.property;
            let warningMsg = paramObject.warningMsg;
            let origName = paramObject.origName;

            if(!angular.isUndefined(model)) {
                $timeout(() => {
                    let params = angular.extend({}, paramObject.filter);
                    params[property] = model;
                    params.size = 200;

                    service[serviceMethod]((success) => {
                        let valid = false;
                        if(!angular.isUndefined(origName)) {
                            if(origName !== model) {
                                valid = (isDuplicate(model, success.content, property))?false:true;
                            } else {
                                valid = true;
                            }

                        } else {
                            valid = (isDuplicate(model, success.content, property))?false:true;
                        }
                        formField.$setValidity('isUnique', valid);
                        toastr.clear();
                        if(!valid) toastr.warning(warningMsg, 'FORM ERROR');
                    }, (error) => {
                        toastr.error('Cannot fetch data list', 'Internal server error');
                    }, params);
                });
            }

        }

        /**
         * Find the duplicate value in the provided array of objects
         * 
         * @param { string | number } needle 
         * @param { [object] } hayStack 
         * @param { string } propName 
         * 
         * @return { boolean } 
         */
        function isDuplicate(needle, hayStack, propName) {
            let duplicates = hayStack.filter((value) => {
                return value[propName] === needle;
            });
            return (duplicates.length !== 0) ? true : false;
        }

        return service;
    }
})()


// WEBPACK FOOTER //
// ./js/services/form-validations/isUniqueService.js